"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    display: _propTypes.default.oneOf(Object.keys(_constant2.DISPLAY)),
    children: _propTypes.default.any.isRequired,
    type: _propTypes.default.oneOf(_constant2.ARR_TEXT_TYPE),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    theme: _propTypes.default.string,
    bold: _propTypes.default.bool,
    strikethrough: _propTypes.default.bool,
    textAlign: _propTypes.default.oneOf(_constant2.TEXT_ALIGN),
    textLimit: _propTypes.default.number,
    direction: _propTypes.default.oneOf(_constant2.TEXT_DIRECTION),
    icon: _propTypes.default.string,
    marginBottom: _propTypes.default.oneOf(_constant.ARR_SPACING_TYPES),
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    verticalAlign: _propTypes.default.string,
    fontSize: _propTypes.default.string,
    hasToggle: _propTypes.default.bool,
    translation: _propTypes.default.shape({
      more: _propTypes.default.string,
      less: _propTypes.default.string
    }),
    tag: _propTypes.default.string,
    opacity: _propTypes.default.number
  },
  DefaultProps: {
    type: _constant2.TEXT_TYPE.default.type,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    display: 'inlineFlex',
    hasToggle: false,
    translation: {},
    tag: _constant2.DEFAULT_TAG,
    opacity: 1
  }
};
exports.default = _default;